import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

const LANGS = [
  { code: 'ru', label: 'RU' },
  { code: 'en', label: 'EN' },
] as const

/**
 * Глобальный переключатель языка интерфейса (RU/EN). Выбор сохраняется в
 * localStorage через хендлер `languageChanged` в `utils/i18n`.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n } = useTranslation()
  const current = i18n.language === 'en' ? 'en' : 'ru'
  return (
    <div
      className={clsx(
        'inline-flex shrink-0 rounded-[var(--stryzh-radius-sm)] border border-[color:var(--stryzh-color-border-default)] p-0.5',
        className,
      )}
    >
      {LANGS.map((l) => {
        const active = current === l.code
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => void i18n.changeLanguage(l.code)}
            aria-pressed={active}
            className={clsx(
              'rounded-[var(--stryzh-radius-sm)] px-2 py-0.5 font-[family-name:var(--stryzh-font-family-mono)] text-[length:var(--stryzh-font-size-xs)] font-semibold transition',
              active
                ? 'bg-[color:var(--stryzh-color-accent-orange)] text-[color:var(--stryzh-color-text-on-orange-badge)]'
                : 'text-[color:var(--stryzh-color-text-secondary)] hover:text-[color:var(--stryzh-color-text-primary)]',
            )}
          >
            {l.label}
          </button>
        )
      })}
    </div>
  )
}
